import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box } from '@mui/material';
import { useState } from "react";
import { ChannelDetail, VideoDetail, SearchFeed, Navbar, Feed } from './components';

const App = () =>{  
  const [color, setColor]= useState(false)
  return(
  
  <BrowserRouter>
    <Box sx={{ backgroundColor: color?"#dadada" :"#121212" }}>
      <Navbar color={color} setColor={setColor} />
      <Routes>
        <Route exact path='/' element={<Feed color={color} />} />
        <Route path='/video/:id' element={<VideoDetail color={color}/>} />
        <Route path='/channel/:id' element={<ChannelDetail color={color} />} />
        <Route path='/search/:searchTerm' element={<SearchFeed color={color} />} />
      </Routes>
    </Box>
  </BrowserRouter>
);
}

export default App;
